module.exports = __webpack_public_path__ + "media/images/bus/conditions/SNAC-ac63d5b07c673c22391eb9c56f26688d.svg";